/* Bearbottom collection card image carousel. See snippets/bb-card-carousel.liquid */
(function () {
  if (window.bbccLoaded) return;
  window.bbccLoaded = true;

  var WIDTHS = [360, 540, 720, 900];
  var mobile = window.matchMedia('(max-width: 768px)');

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // The JSON only carries the 720px URL; build the other widths from it.
  function srcset(src) {
    return WIDTHS.map(function (w) {
      return src.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function setup(root) {
    if (root.getAttribute('data-bbcc-ready')) return;
    root.setAttribute('data-bbcc-ready', '1');

    var id = root.getAttribute('data-bbcc');
    var title = root.getAttribute('data-bbcc-title') || '';
    var sizes = root.getAttribute('data-bbcc-sizes') || '50vw';
    var color = root.getAttribute('data-bbcc-color') || '';
    var card = root.closest('.grid-product') || root.parentNode;
    var track = root.querySelector('.bbcc__track');
    var live = root.querySelector('.bbcc__live');
    var prev = root.querySelector('.bbcc__arrow--prev');
    var next = root.querySelector('.bbcc__arrow--next');
    var index = 0;
    var data = {};
    var dataEl = card.querySelector('script[data-bbcc-data="' + id + '"]');
    try { data = JSON.parse(dataEl.textContent); } catch (e) {}

    function slides() { return track.children; }

    function update(announce) {
      var list = slides();
      var n = list.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var k = 0; k < n; k++) {
        if (k === index) list[k].removeAttribute('aria-hidden');
        else list[k].setAttribute('aria-hidden', 'true');
      }
      if (prev) prev.hidden = n < 2;
      if (next) next.hidden = n < 2;
      if (announce && live) live.textContent = 'Image ' + (index + 1) + ' of ' + n;
    }

    function go(step) {
      var n = slides().length;
      if (n < 2) return;
      index = (index + step + n) % n;
      update(true);
    }

    // Load every slide once the shopper shows interest, so swipes feel instant.
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      var imgs = track.querySelectorAll('img[loading="lazy"]');
      for (var k = 0; k < imgs.length; k++) imgs[k].loading = 'eager';
    }
    card.addEventListener('mouseenter', warm);
    card.addEventListener('focusin', warm);
    card.addEventListener('touchstart', warm, { passive: true });

    function stop(e) { e.preventDefault(); e.stopPropagation(); }
    if (prev) prev.addEventListener('click', function (e) { stop(e); go(-1); });
    if (next) next.addEventListener('click', function (e) { stop(e); go(1); });

    function slideHtml(s, k, name) {
      return '<div class="bbcc__slide"' + (k ? ' aria-hidden="true"' : '') + '>' +
        '<img class="bbcc__img" src="' + esc(s.src) + '" srcset="' + esc(srcset(s.src)) + '" sizes="' + esc(sizes) + '"' +
        ' width="' + s.w + '" height="' + s.h + '" alt="' + (k ? '' : esc(title + (name ? ', ' + name : ''))) + '"' +
        (k && !warmed ? ' loading="lazy"' : '') + '></div>';
    }

    // Only the first slide comes from the server. Add the rest for this color.
    var initial = data[color];
    if (initial && initial.length > 1 && slides().length === 1) {
      track.insertAdjacentHTML('beforeend', initial.slice(1).map(function (s, k) {
        return slideHtml(s, k + 1, color);
      }).join(''));
    }

    function showColor(name) {
      var list = data[name];
      if (!list || !list.length) return;
      if (name !== color) {
        color = name;
        track.innerHTML = list.map(function (s, k) { return slideHtml(s, k, name); }).join('');
      }
      index = 0;
      update(false);
    }

    // On phones, color swatches select which color's images the carousel shows.
    // On desktop they keep the theme's normal behavior (link to that color).
    var swatches = card.querySelectorAll('.grid-product__colors .color-swatch');
    function markSwatches() {
      for (var k = 0; k < swatches.length; k++) {
        var sw = swatches[k];
        if (!sw._bbccName) continue;
        if (mobile.matches) {
          sw.setAttribute('role', 'button');
          sw.setAttribute('aria-pressed', sw._bbccName === color ? 'true' : 'false');
        } else {
          sw.removeAttribute('role');
          sw.removeAttribute('aria-pressed');
        }
      }
    }
    root._bbccMark = markSwatches;
    Array.prototype.forEach.call(swatches, function (sw) {
      var label = sw.querySelector('.visually-hidden');
      var name = (label ? label.textContent : '').trim();
      if (!data[name]) return;
      sw._bbccName = name;
      sw.addEventListener('click', function (e) {
        if (!mobile.matches) return;
        stop(e);
        showColor(name);
        markSwatches();
      });
      sw.addEventListener('keydown', function (e) {
        if (!mobile.matches) return;
        if (e.key === ' ' || e.key === 'Spacebar') { stop(e); sw.click(); }
      });
    });
    markSwatches();

    // Swipe on touch screens. The card link overlays the image, so listen on the wrapper.
    var area = root.closest('.grid__item-image-wrapper') || root;
    var startX = null;
    var startY = null;
    var swiped = false;
    area.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    area.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        go(dx < 0 ? 1 : -1);
        swiped = true;
        setTimeout(function () { swiped = false; }, 400);
      }
    }, { passive: true });
    area.addEventListener('click', function (e) {
      if (swiped) stop(e);
    }, true);

    update(false);
  }

  function init() {
    var roots = document.querySelectorAll('[data-bbcc]:not([data-bbcc-ready])');
    for (var k = 0; k < roots.length; k++) setup(roots[k]);
  }

  // One listener for all cards, so cards replaced by filters don't leak listeners.
  function remark() {
    var roots = document.querySelectorAll('[data-bbcc-ready]');
    for (var k = 0; k < roots.length; k++) if (roots[k]._bbccMark) roots[k]._bbccMark();
  }
  if (mobile.addEventListener) mobile.addEventListener('change', remark);
  else if (mobile.addListener) mobile.addListener(remark);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Collection filters and sorting reload the grid with AJAX.
  var queued = false;
  new MutationObserver(function (records) {
    if (queued) return;
    for (var k = 0; k < records.length; k++) {
      if (records[k].addedNodes.length) {
        queued = true;
        requestAnimationFrame(function () { queued = false; init(); });
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
